import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import {
    BrandAlphabetModel,
    BrandCategoryCollectionModel,
    BrandCollectionModel,
    BrandModel,
    CategoryCollectionModel,
} from "@insite/client-framework/Types/ApiModels";

export interface GetBrandByPathApiParameter extends ApiParameter {
    path: string;
}
export interface GetCategoriesApiParameter extends ApiParameter {
    maxDepth?: number;
    startCategoryId?: string;
    includeStartCategory?: boolean;
}
export interface GetBrandsApiParameter extends ApiParameter, HasPagingParameters {
    select?: string;
    startsWith?: string;
    manufacturer?: string;
    expand?: string;
    brandIds?: string[];
    randomize?: boolean;
    additionalExpands?: string[];
}

const newBrandAlphabetUrl = "/api/v2/centrobrandalphabet";
const newBrandsUrl = "/api/v2/centrobrands";
const categoriesAllBrandUrl = 'api/v1/categories';

export function getBrandAlphabet() {
    return get<BrandAlphabetModel>(`${newBrandAlphabetUrl}/`, {});
}

export function getBrandByPath(parameter: GetBrandByPathApiParameter) {
    return get<BrandModel>(`${newBrandsUrl}/getByPath`, parameter);
}

export function getBrands(parameter: GetBrandsApiParameter) {
    return get<BrandCollectionModel>(`${newBrandsUrl}/`, parameter);
}

export function getCategoriesofAllBrands(parameter?: GetCategoriesApiParameter) {
    return get<CategoryCollectionModel>(`${categoriesAllBrandUrl}/`,parameter);
}